// extracted by mini-css-extract-plugin
export default {"formulario":"Pagamento_formulario__PKX-x","input":"Pagamento_input__t-2Kt","botaoContainer":"Pagamento_botaoContainer__EZqKz","botao":"Pagamento_botao__OT5Zi"};